interface OrganizationAdminMembership {
    organization: { id: string };
    explicitRoleAssignments: Array<{
        role: string;
        scopeId: string;
        status?: string;
    }>;
}

export const isOrganizationAdminMembership = (membership: OrganizationAdminMembership | null): boolean =>
    membership?.explicitRoleAssignments.some(
        assignment => assignment.role === "Organization Admin" && assignment.scopeId === membership.organization.id && assignment.status !== "Ended"
    ) ?? false;

/** Nykraft keeps HR-capable Unit Managers, but delegates this page to its Org Admin. */
export const canAccessOrganizationAdministration = (
    membership: OrganizationAdminMembership | null,
    canAdminister: boolean,
    requiresOrganizationAdmin: boolean
): boolean => membership !== null && (requiresOrganizationAdmin ? isOrganizationAdminMembership(membership) : canAdminister);

// The isolated migration fixture represents the same organization under a distinct ID.
// Keep this exact alias explicit so a normal rebuild cannot drop its access policy.
const organizationAdminOnlyIds: ReadonlySet<string> = new Set(["Nykraft_Assistans", "review-20261013-Nykraft_Assistans"]);

export const requiresOrganizationAdminForAdministration = (organizationId: string | undefined): boolean => organizationAdminOnlyIds.has(organizationId ?? "");
